// @flow
import * as React from 'react';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import { Fill, Grid } from 'layout-core-components';
import { Heading, Button } from 'primitive-components';
import { colors, elevation } from 'bench-style-constants';

const StyledModalContainer = styled.div`
  transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out;

  &.modal-appear {
    opacity: 0;
    transform: scale(1.025);
  }
  &.modal-appear-active {
    opacity: 1;
    transform: scale(1);

    transition: opacity 0.25s ease-out, transform 0.25s ease-out;
  }

  &.modal-exit {
    opacity: 1;
    transform: scale(1);
  }
  &.modal-exit-active {
    opacity: 0;
    transform: scale(1.025);

    transition: opacity 0.25s ease-in, transform 0.25s ease-in;
  }
`;

const StyledTitleBar = styled.div`
  position: relative;
  padding: 16px 20px;
  background-color: ${colors.white};
  box-shadow: ${elevation.level1};
`;

const StyledHeading = styled(Heading)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const StyledCloseButton = styled(Button)`
  float: right;
`;

const StyledContentArea = styled.div`
  background-color: ${colors.pearl};
  padding: 32px;
`;

type FullscreenTitledModalProps = {
  children: React.Node,
  title: string,
  close: Function,
};

type FullscreenTitledModalState = {
  showModal: boolean,
};

export default class FullscreenTitledModal extends React.Component<
  FullscreenTitledModalProps,
  FullscreenTitledModalState,
> {
  state = {
    showModal: true,
  };

  render() {
    const { title, close, children } = this.props;
    const { showModal } = this.state;
    return (
      <Fill to="parent">
        <CSSTransition appear classNames="modal" in={showModal} timeout={250} onExited={close}>
          <StyledModalContainer>
            <Fill to="parent">
              <Grid column="max-content auto">
                <StyledTitleBar>
                  <StyledHeading size={2}>{title}</StyledHeading>
                  <StyledCloseButton
                    subtle
                    styleType="neutral"
                    iconRight="close"
                    onClick={() => this.setState({ showModal: false })}
                  >
                    Close
                  </StyledCloseButton>
                </StyledTitleBar>
                <StyledContentArea>{children}</StyledContentArea>
              </Grid>
            </Fill>
          </StyledModalContainer>
        </CSSTransition>
      </Fill>
    );
  }
}
